module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      n.d(r, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return r;
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 7);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  "use strict";

  var r,
      o = "object" == typeof Reflect ? Reflect : null,
      i = o && "function" == typeof o.apply ? o.apply : function (e, t, n) {
    return Function.prototype.apply.call(e, t, n);
  };
  r = o && "function" == typeof o.ownKeys ? o.ownKeys : Object.getOwnPropertySymbols ? function (e) {
    return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
  } : function (e) {
    return Object.getOwnPropertyNames(e);
  };

  var s = Number.isNaN || function (e) {
    return e != e;
  };

  function a() {
    a.init.call(this);
  }

  e.exports = a, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
  var u = 10;

  function l(e) {
    return void 0 === e._maxListeners ? a.defaultMaxListeners : e._maxListeners;
  }

  function c(e, t, n, r) {
    var o, i, s, a;
    if ("function" != typeof n) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof n);
    if (void 0 === (i = e._events) ? (i = e._events = Object.create(null), e._eventsCount = 0) : (void 0 !== i.newListener && (e.emit("newListener", t, n.listener ? n.listener : n), i = e._events), s = i[t]), void 0 === s) s = i[t] = n, ++e._eventsCount;else if ("function" == typeof s ? s = i[t] = r ? [n, s] : [s, n] : r ? s.unshift(n) : s.push(n), (o = l(e)) > 0 && s.length > o && !s.warned) {
      s.warned = !0;
      var u = new Error("Possible EventEmitter memory leak detected. " + s.length + " " + String(t) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      u.name = "MaxListenersExceededWarning", u.emitter = e, u.type = t, u.count = s.length, a = u, console && console.warn && console.warn(a);
    }
    return e;
  }

  function p() {
    for (var e = [], t = 0; t < arguments.length; t++) {
      e.push(arguments[t]);
    }

    this.fired || (this.target.removeListener(this.type, this.wrapFn), this.fired = !0, i(this.listener, this.target, e));
  }

  function f(e, t, n) {
    var r = {
      fired: !1,
      wrapFn: void 0,
      target: e,
      type: t,
      listener: n
    },
        o = p.bind(r);
    return o.listener = n, r.wrapFn = o, o;
  }

  function h(e, t, n) {
    var r = e._events;
    if (void 0 === r) return [];
    var o = r[t];
    return void 0 === o ? [] : "function" == typeof o ? n ? [o.listener || o] : [o] : n ? function (e) {
      for (var t = new Array(e.length), n = 0; n < t.length; ++n) {
        t[n] = e[n].listener || e[n];
      }

      return t;
    }(o) : y(o, o.length);
  }

  function d(e) {
    var t = this._events;

    if (void 0 !== t) {
      var n = t[e];
      if ("function" == typeof n) return 1;
      if (void 0 !== n) return n.length;
    }

    return 0;
  }

  function y(e, t) {
    for (var n = new Array(t), r = 0; r < t; ++r) {
      n[r] = e[r];
    }

    return n;
  }

  Object.defineProperty(a, "defaultMaxListeners", {
    enumerable: !0,
    get: function get() {
      return u;
    },
    set: function set(e) {
      if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
      u = e;
    }
  }), a.init = function () {
    void 0 !== this._events && this._events !== Object.getPrototypeOf(this)._events || (this._events = Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, a.prototype.setMaxListeners = function (e) {
    if ("number" != typeof e || e < 0 || s(e)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
    return this._maxListeners = e, this;
  }, a.prototype.getMaxListeners = function () {
    return l(this);
  }, a.prototype.emit = function (e) {
    for (var t = [], n = 1; n < arguments.length; n++) {
      t.push(arguments[n]);
    }

    var r = "error" === e,
        o = this._events;
    if (void 0 !== o) r = r && void 0 === o.error;else if (!r) return !1;

    if (r) {
      var s;
      if (t.length > 0 && (s = t[0]), s instanceof Error) throw s;
      var a = new Error("Unhandled error." + (s ? " (" + s.message + ")" : ""));
      throw a.context = s, a;
    }

    var u = o[e];
    if (void 0 === u) return !1;
    if ("function" == typeof u) i(u, this, t);else {
      var l = u.length,
          c = y(u, l);

      for (n = 0; n < l; ++n) {
        i(c[n], this, t);
      }
    }
    return !0;
  }, a.prototype.addListener = function (e, t) {
    return c(this, e, t, !1);
  }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function (e, t) {
    return c(this, e, t, !0);
  }, a.prototype.once = function (e, t) {
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    return this.on(e, f(this, e, t)), this;
  }, a.prototype.prependOnceListener = function (e, t) {
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    return this.prependListener(e, f(this, e, t)), this;
  }, a.prototype.removeListener = function (e, t) {
    var n, r, o, i, s;
    if ("function" != typeof t) throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof t);
    if (void 0 === (r = this._events)) return this;
    if (void 0 === (n = r[e])) return this;
    if (n === t || n.listener === t) 0 == --this._eventsCount ? this._events = Object.create(null) : (delete r[e], r.removeListener && this.emit("removeListener", e, n.listener || t));else if ("function" != typeof n) {
      for (o = -1, i = n.length - 1; i >= 0; i--) {
        if (n[i] === t || n[i].listener === t) {
          s = n[i].listener, o = i;
          break;
        }
      }

      if (o < 0) return this;
      0 === o ? n.shift() : function (e, t) {
        for (; t + 1 < e.length; t++) {
          e[t] = e[t + 1];
        }

        e.pop();
      }(n, o), 1 === n.length && (r[e] = n[0]), void 0 !== r.removeListener && this.emit("removeListener", e, s || t);
    }
    return this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function (e) {
    var t, n, r;
    if (void 0 === (n = this._events)) return this;
    if (void 0 === n.removeListener) return 0 === arguments.length ? (this._events = Object.create(null), this._eventsCount = 0) : void 0 !== n[e] && (0 == --this._eventsCount ? this._events = Object.create(null) : delete n[e]), this;

    if (0 === arguments.length) {
      var o,
          i = Object.keys(n);

      for (r = 0; r < i.length; ++r) {
        "removeListener" !== (o = i[r]) && this.removeAllListeners(o);
      }

      return this.removeAllListeners("removeListener"), this._events = Object.create(null), this._eventsCount = 0, this;
    }

    if ("function" == typeof (t = n[e])) this.removeListener(e, t);else if (void 0 !== t) for (r = t.length - 1; r >= 0; r--) {
      this.removeListener(e, t[r]);
    }
    return this;
  }, a.prototype.listeners = function (e) {
    return h(this, e, !0);
  }, a.prototype.rawListeners = function (e) {
    return h(this, e, !1);
  }, a.listenerCount = function (e, t) {
    return "function" == typeof e.listenerCount ? e.listenerCount(t) : d.call(e, t);
  }, a.prototype.listenerCount = d, a.prototype.eventNames = function () {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
}, function (e, t, n) {
  "use strict";

  var r = n(3),
      o = n(4),
      i = n(6);

  e.exports = function (e) {
    var t = o(String(e)).toLowerCase().replace(v, "").split(m),
        n = t.length,
        r = -1,
        i = 0;

    for (; ++r < n;) {
      i += b(t[r].replace(g, ""));
    }

    return i;
  };

  var s = {}.hasOwnProperty,
      a = new RegExp(["awe($|d|so)", "cia(?:l|$)", "tia", "cius", "cious", "[^aeiou]giu", "[aeiouy][^aeiouy]ion", "iou", "sia$", "eous$", "[oa]gue$", ".[^aeiuoycgltdb]{2,}ed$", ".ely$", "^jua", "uai", "eau", "^busi$", "(?:[aeiouy](?:" + ["[bcfgklmnprsvwxyz]", "ch", "dg", "g[hn]", "lch", "l[lv]", "mm", "nch", "n[cgn]", "r[bcnsv]", "squ", "s[chkls]", "th"].join("|") + ")ed$)", "(?:[aeiouy](?:" + ["[bdfklmnprstvy]", "ch", "g[hn]", "lch", "l[lv]", "mm", "nch", "nn", "r[nsv]", "squ", "s[cklst]", "th"].join("|") + ")es$)"].join("|"), "g"),
      u = new RegExp("[aeiouy](?:" + ["[bcdfgklmnprstvyz]", "ch", "dg", "g[hn]", "l[lv]", "mm", "n[cgn]", "r[cnsv]", "squ", "s[cklst]", "th"].join("|") + ")e$", "g"),
      l = new RegExp("(?:" + ["([^aeiouy])\\1l", "[^aeiouy]ie(?:r|s?t)", "[aeiouym]bl", "eo", "ism", "asm", "thm", "dnt", "snt", "uity", "dea", "gean", "oa", "ua", "react?", "orbed", "eings?", "[aeiouy]sh?e[rs]"].join("|") + ")$", "g"),
      c = new RegExp(["creat(?!u)", "[^gq]ua[^auieo]", "[aeiou]{3}", "^(?:ia|mc|coa[dglx].)", "^re(app|es|im|us)"].join("|"), "g"),
      p = new RegExp(["[^aeiou]y[ae]", "[^l]lien", "riet", "dien", "iu", "io", "ii", "uen", "[aeilotu]real", "real[aeilotu]", "iell", "eo[^aeiou]", "[aeiou]y[aeiou]"].join("|"), "g"),
      f = /[^s]ia/,
      h = new RegExp(["^(?:" + ["un", "fore", "ware", "none?", "out", "post", "sub", "pre", "pro", "dis", "side", "some"].join("|") + ")", "(?:" + ["ly", "less", "some", "ful", "ers?", "ness", "cians?", "ments?", "ettes?", "villes?", "ships?", "sides?", "ports?", "shires?", "tion(?:ed|s)?"].join("|") + ")$"].join("|"), "g"),
      d = new RegExp(["^(?:" + ["above", "anti", "ante", "counter", "hyper", "afore", "agri", "infra", "intra", "inter", "over", "semi", "ultra", "under", "extra", "dia", "micro", "mega", "kilo", "pico", "nano", "macro", "somer"].join("|") + ")", "(?:fully|berry|woman|women|edly)$"].join("|"), "g"),
      y = /(creations?|ology|ologist|onomy|onomist)$/g,
      m = /\b/g,
      v = /['’]/g,
      g = /[^a-z]/g;

  function b(e) {
    var t,
        n,
        o,
        m,
        v,
        g,
        b = 0;
    if (0 === e.length) return b;
    if (e.length < 3) return 1;
    if (s.call(i, e)) return i[e];
    if (o = r(e, 1), s.call(i, o)) return i[o];

    for (v = x(1), g = x(-1), t = -1, n = (m = (e = e.replace(y, w(3)).replace(d, w(2)).replace(h, w(1))).split(/[^aeiouy]+/)).length; ++t < n;) {
      "" !== m[t] && b++;
    }

    return e.replace(a, g).replace(u, g), e.replace(l, v).replace(c, v).replace(p, v).replace(f, v), b || 1;

    function w(e) {
      return function () {
        return b += e, "";
      };
    }

    function x(e) {
      return function (t) {
        return b += e, t;
      };
    }
  }
}, function (e, t, n) {
  e.exports = function () {
    var e = [],
        t = [],
        n = {},
        r = {},
        o = {};

    function i(e) {
      return "string" == typeof e ? new RegExp("^" + e + "$", "i") : e;
    }

    function s(e, t) {
      return e === t ? t : e === e.toLowerCase() ? t.toLowerCase() : e === e.toUpperCase() ? t.toUpperCase() : e[0] === e[0].toUpperCase() ? t.charAt(0).toUpperCase() + t.substr(1).toLowerCase() : t.toLowerCase();
    }

    function a(e, t) {
      return e.replace(/\$(\d{1,2})/g, function (e, n) {
        return t[n] || "";
      });
    }

    function u(e, t) {
      return e.replace(t[0], function (n, r) {
        var o = a(t[1], arguments);
        return s("" === n ? e[r - 1] : n, o);
      });
    }

    function l(e, t, r) {
      if (!e.length || n.hasOwnProperty(e)) return t;

      for (var o = r.length; o--;) {
        var i = r[o];
        if (i[0].test(t)) return u(t, i);
      }

      return t;
    }

    function c(e, t, n) {
      return function (r) {
        var o = r.toLowerCase();
        return t.hasOwnProperty(o) ? s(r, o) : e.hasOwnProperty(o) ? s(r, e[o]) : l(o, r, n);
      };
    }

    function p(e, t, n, r) {
      return function (r) {
        var o = r.toLowerCase();
        return !!t.hasOwnProperty(o) || !e.hasOwnProperty(o) && l(o, o, n) === o;
      };
    }

    function f(e, t, n) {
      return (n ? t + " " : "") + (1 === t ? f.singular(e) : f.plural(e));
    }

    return f.plural = c(o, r, e), f.isPlural = p(o, r, e), f.singular = c(r, o, t), f.isSingular = p(r, o, t), f.addPluralRule = function (t, n) {
      e.push([i(t), n]);
    }, f.addSingularRule = function (e, n) {
      t.push([i(e), n]);
    }, f.addUncountableRule = function (e) {
      "string" != typeof e ? (f.addPluralRule(e, "$0"), f.addSingularRule(e, "$0")) : n[e.toLowerCase()] = !0;
    }, f.addIrregularRule = function (e, t) {
      t = t.toLowerCase(), e = e.toLowerCase(), o[e] = t, r[t] = e;
    }, [["I", "we"], ["me", "us"], ["he", "they"], ["she", "they"], ["them", "them"], ["myself", "ourselves"], ["yourself", "yourselves"], ["itself", "themselves"], ["herself", "themselves"], ["himself", "themselves"], ["themself", "themselves"], ["is", "are"], ["was", "were"], ["has", "have"], ["this", "these"], ["that", "those"], ["echo", "echoes"], ["dingo", "dingoes"], ["volcano", "volcanoes"], ["tornado", "tornadoes"], ["torpedo", "torpedoes"], ["genus", "genera"], ["viscus", "viscera"], ["stigma", "stigmata"], ["stoma", "stomata"], ["dogma", "dogmata"], ["lemma", "lemmata"], ["schema", "schemata"], ["anathema", "anathemata"], ["ox", "oxen"], ["axe", "axes"], ["die", "dice"], ["yes", "yeses"], ["foot", "feet"], ["eave", "eaves"], ["goose", "geese"], ["tooth", "teeth"], ["quiz", "quizzes"], ["human", "humans"], ["proof", "proofs"], ["carve", "carves"], ["valve", "valves"], ["looey", "looies"], ["thief", "thieves"], ["groove", "grooves"], ["pickaxe", "pickaxes"], ["passerby", "passersby"]].forEach(function (e) {
      return f.addIrregularRule(e[0], e[1]);
    }), [[/s?$/i, "s"], [/[^\u0000-\u007F]$/i, "$0"], [/([^aeiou]ese)$/i, "$1"], [/(ax|test)is$/i, "$1es"], [/(alias|[^aou]us|t[lm]as|gas|ris)$/i, "$1es"], [/(e[mn]u)s?$/i, "$1s"], [/([^l]ias|[aeiou]las|[ejzr]as|[iu]am)$/i, "$1"], [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1i"], [/(alumn|alg|vertebr)(?:a|ae)$/i, "$1ae"], [/(seraph|cherub)(?:im)?$/i, "$1im"], [/(her|at|gr)o$/i, "$1oes"], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|automat|quor)(?:a|um)$/i, "$1a"], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)(?:a|on)$/i, "$1a"], [/sis$/i, "ses"], [/(?:(kni|wi|li)fe|(ar|l|ea|eo|oa|hoo)f)$/i, "$1$2ves"], [/([^aeiouy]|qu)y$/i, "$1ies"], [/([^ch][ieo][ln])ey$/i, "$1ies"], [/(x|ch|ss|sh|zz)$/i, "$1es"], [/(matr|cod|mur|sil|vert|ind|append)(?:ix|ex)$/i, "$1ices"], [/\b((?:tit)?m|l)(?:ice|ouse)$/i, "$1ice"], [/(pe)(?:rson|ople)$/i, "$1ople"], [/(child)(?:ren)?$/i, "$1ren"], [/eaux$/i, "$0"], [/m[ae]n$/i, "men"], ["thou", "you"]].forEach(function (e) {
      return f.addPluralRule(e[0], e[1]);
    }), [[/s$/i, ""], [/(ss)$/i, "$1"], [/(wi|kni|(?:after|half|high|low|mid|non|night|[^\w]|^)li)ves$/i, "$1fe"], [/(ar|(?:wo|[ae])l|[eo][ao])ves$/i, "$1f"], [/ies$/i, "y"], [/\b([pl]|zomb|(?:neck|cross)?t|coll|faer|food|gen|goon|group|lass|talk|goal|cut)ies$/i, "$1ie"], [/\b(mon|smil)ies$/i, "$1ey"], [/\b((?:tit)?m|l)ice$/i, "$1ouse"], [/(seraph|cherub)im$/i, "$1"], [/(x|ch|ss|sh|zz|tto|go|cho|alias|[^aou]us|t[lm]as|gas|(?:her|at|gr)o|[aeiou]ris)(?:es)?$/i, "$1"], [/(analy|diagno|parenthe|progno|synop|the|empha|cri|ne)(?:sis|ses)$/i, "$1sis"], [/(movie|twelve|abuse|e[mn]u)s$/i, "$1"], [/(test)(?:is|es)$/i, "$1is"], [/(alumn|syllab|vir|radi|nucle|fung|cact|stimul|termin|bacill|foc|uter|loc|strat)(?:us|i)$/i, "$1us"], [/(agend|addend|millenni|dat|extrem|bacteri|desiderat|strat|candelabr|errat|ov|symposi|curricul|quor)a$/i, "$1um"], [/(apheli|hyperbat|periheli|asyndet|noumen|phenomen|criteri|organ|prolegomen|hedr|automat)a$/i, "$1on"], [/(alumn|alg|vertebr)ae$/i, "$1a"], [/(cod|mur|sil|vert|ind)ices$/i, "$1ex"], [/(matr|append)ices$/i, "$1ix"], [/(pe)(rson|ople)$/i, "$1rson"], [/(child)ren$/i, "$1"], [/(eau)x?$/i, "$1"], [/men$/i, "man"]].forEach(function (e) {
      return f.addSingularRule(e[0], e[1]);
    }), ["adulthood", "advice", "agenda", "aid", "aircraft", "alcohol", "ammo", "analytics", "anime", "athletics", "audio", "bison", "blood", "bream", "buffalo", "butter", "carp", "cash", "chassis", "chess", "clothing", "cod", "commerce", "cooperation", "corps", "debris", "diabetes", "digestion", "elk", "energy", "equipment", "excretion", "expertise", "firmware", "flounder", "fun", "gallows", "garbage", "graffiti", "hardware", "headquarters", "health", "herpes", "highjinks", "homework", "housework", "information", "jeans", "justice", "kudos", "labour", "literature", "machinery", "mackerel", "mail", "media", "mews", "moose", "music", "mud", "manga", "news", "only", "personnel", "pike", "plankton", "pliers", "police", "pollution", "premises", "rain", "research", "rice", "salmon", "scissors", "series", "sewage", "shambles", "shrimp", "software", "species", "staff", "swine", "tennis", "traffic", "transportation", "trout", "tuna", "wealth", "welfare", "whiting", "wildebeest", "wildlife", "you", /pok[eé]mon$/i, /[^aeiou]ese$/i, /deer$/i, /fish$/i, /measles$/i, /o[iu]s$/i, /pox$/i, /sheep$/i].forEach(f.addUncountableRule), f;
  }();
}, function (e, t, n) {
  var r, o;
  o = "undefined" != typeof window ? window : this, void 0 === (r = function () {
    return o.document, r = n(5), i = null, function (n, o) {
      return t = e, e = o || r, i = i && t === e ? i : function (e) {
        return new RegExp("[" + Object.keys(e).map(function (e) {
          return String.fromCharCode(e);
        }).join(" ") + "]", "g");
      }(e), n.replace(i, function (t) {
        return e[t.charCodeAt(0)] || t;
      });
    };
    var e, t, r, i;
  }.call(t, n, t, e)) || (e.exports = r);
}, function (e) {
  e.exports = {
    105: "i",
    192: "A",
    193: "A",
    194: "A",
    195: "A",
    196: "A",
    197: "A",
    199: "C",
    200: "E",
    201: "E",
    202: "E",
    203: "E",
    204: "I",
    205: "I",
    206: "I",
    207: "I",
    209: "N",
    210: "O",
    211: "O",
    212: "O",
    213: "O",
    214: "O",
    216: "O",
    217: "U",
    218: "U",
    219: "U",
    220: "U",
    221: "Y",
    224: "a",
    225: "a",
    226: "a",
    227: "a",
    228: "a",
    229: "a",
    231: "c",
    232: "e",
    233: "e",
    234: "e",
    235: "e",
    236: "i",
    237: "i",
    238: "i",
    239: "i",
    241: "n",
    242: "o",
    243: "o",
    244: "o",
    245: "o",
    246: "o",
    248: "o",
    249: "u",
    250: "u",
    251: "u",
    252: "u",
    253: "y",
    255: "y",
    256: "A",
    257: "a",
    258: "A",
    259: "a",
    260: "A",
    261: "a",
    262: "C",
    263: "c",
    264: "C",
    265: "c",
    266: "C",
    267: "c",
    268: "C",
    269: "c",
    270: "D",
    271: "d",
    272: "D",
    273: "d",
    274: "E",
    275: "e",
    276: "E",
    277: "e",
    278: "E",
    279: "e",
    280: "E",
    281: "e",
    282: "E",
    283: "e",
    284: "G",
    285: "g",
    286: "G",
    287: "g",
    288: "G",
    289: "g",
    290: "G",
    291: "g",
    292: "H",
    293: "h",
    294: "H",
    295: "h",
    296: "I",
    297: "i",
    298: "I",
    299: "i",
    300: "I",
    301: "i",
    302: "I",
    303: "i",
    304: "I",
    308: "J",
    309: "j",
    310: "K",
    311: "k",
    313: "L",
    314: "l",
    315: "L",
    316: "l",
    317: "L",
    318: "l",
    319: "L",
    320: "l",
    321: "L",
    322: "l",
    323: "N",
    324: "n",
    325: "N",
    326: "n",
    327: "N",
    328: "n",
    332: "O",
    333: "o",
    334: "O",
    335: "o",
    336: "O",
    337: "o",
    338: "O",
    339: "o",
    340: "R",
    341: "r",
    342: "R",
    343: "r",
    344: "R",
    345: "r",
    346: "S",
    347: "s",
    348: "S",
    349: "s",
    350: "S",
    351: "s",
    352: "S",
    353: "s",
    354: "T",
    355: "t",
    356: "T",
    357: "t",
    358: "T",
    359: "t",
    360: "U",
    361: "u",
    362: "U",
    363: "u",
    364: "U",
    365: "u",
    366: "U",
    367: "u",
    368: "U",
    369: "u",
    370: "U",
    371: "u",
    372: "W",
    373: "w",
    374: "Y",
    375: "y",
    376: "Y",
    377: "Z",
    378: "z",
    379: "Z",
    380: "z",
    381: "Z",
    382: "z",
    384: "b",
    385: "B",
    386: "B",
    387: "b",
    390: "O",
    391: "C",
    392: "c",
    393: "D",
    394: "D",
    395: "D",
    396: "d",
    398: "E",
    400: "E",
    401: "F",
    402: "f",
    403: "G",
    407: "I",
    408: "K",
    409: "k",
    410: "l",
    412: "M",
    413: "N",
    414: "n",
    415: "O",
    416: "O",
    417: "o",
    420: "P",
    421: "p",
    422: "R",
    427: "t",
    428: "T",
    429: "t",
    430: "T",
    431: "U",
    432: "u",
    434: "V",
    435: "Y",
    436: "y",
    437: "Z",
    438: "z",
    461: "A",
    462: "a",
    463: "I",
    464: "i",
    465: "O",
    466: "o",
    467: "U",
    468: "u",
    477: "e",
    484: "G",
    485: "g",
    486: "G",
    487: "g",
    488: "K",
    489: "k",
    490: "O",
    491: "o",
    500: "G",
    501: "g",
    504: "N",
    505: "n",
    512: "A",
    513: "a",
    514: "A",
    515: "a",
    516: "E",
    517: "e",
    518: "E",
    519: "e",
    520: "I",
    521: "i",
    522: "I",
    523: "i",
    524: "O",
    525: "o",
    526: "O",
    527: "o",
    528: "R",
    529: "r",
    530: "R",
    531: "r",
    532: "U",
    533: "u",
    534: "U",
    535: "u",
    536: "S",
    537: "s",
    538: "T",
    539: "t",
    542: "H",
    543: "h",
    544: "N",
    545: "d",
    548: "Z",
    549: "z",
    550: "A",
    551: "a",
    552: "E",
    553: "e",
    558: "O",
    559: "o",
    562: "Y",
    563: "y",
    564: "l",
    565: "n",
    566: "t",
    567: "j",
    570: "A",
    571: "C",
    572: "c",
    573: "L",
    574: "T",
    575: "s",
    576: "z",
    579: "B",
    580: "U",
    581: "V",
    582: "E",
    583: "e",
    584: "J",
    585: "j",
    586: "Q",
    587: "q",
    588: "R",
    589: "r",
    590: "Y",
    591: "y",
    592: "a",
    593: "a",
    595: "b",
    596: "o",
    597: "c",
    598: "d",
    599: "d",
    600: "e",
    603: "e",
    604: "e",
    605: "e",
    606: "e",
    607: "j",
    608: "g",
    609: "g",
    610: "g",
    613: "h",
    614: "h",
    616: "i",
    618: "i",
    619: "l",
    620: "l",
    621: "l",
    623: "m",
    624: "m",
    625: "m",
    626: "n",
    627: "n",
    628: "n",
    629: "o",
    633: "r",
    634: "r",
    635: "r",
    636: "r",
    637: "r",
    638: "r",
    639: "r",
    640: "r",
    641: "r",
    642: "s",
    647: "t",
    648: "t",
    649: "u",
    651: "v",
    652: "v",
    653: "w",
    654: "y",
    655: "y",
    656: "z",
    657: "z",
    663: "c",
    665: "b",
    666: "e",
    667: "g",
    668: "h",
    669: "j",
    670: "k",
    671: "l",
    672: "q",
    686: "h",
    688: "h",
    690: "j",
    691: "r",
    692: "r",
    694: "r",
    695: "w",
    696: "y",
    737: "l",
    738: "s",
    739: "x",
    780: "v",
    829: "x",
    851: "x",
    867: "a",
    868: "e",
    869: "i",
    870: "o",
    871: "u",
    872: "c",
    873: "d",
    874: "h",
    875: "m",
    876: "r",
    877: "t",
    878: "v",
    879: "x",
    7424: "a",
    7427: "b",
    7428: "c",
    7429: "d",
    7431: "e",
    7432: "e",
    7433: "i",
    7434: "j",
    7435: "k",
    7436: "l",
    7437: "m",
    7438: "n",
    7439: "o",
    7440: "o",
    7441: "o",
    7442: "o",
    7443: "o",
    7446: "o",
    7447: "o",
    7448: "p",
    7449: "r",
    7450: "r",
    7451: "t",
    7452: "u",
    7453: "u",
    7454: "u",
    7455: "m",
    7456: "v",
    7457: "w",
    7458: "z",
    7522: "i",
    7523: "r",
    7524: "u",
    7525: "v",
    7680: "A",
    7681: "a",
    7682: "B",
    7683: "b",
    7684: "B",
    7685: "b",
    7686: "B",
    7687: "b",
    7690: "D",
    7691: "d",
    7692: "D",
    7693: "d",
    7694: "D",
    7695: "d",
    7696: "D",
    7697: "d",
    7698: "D",
    7699: "d",
    7704: "E",
    7705: "e",
    7706: "E",
    7707: "e",
    7710: "F",
    7711: "f",
    7712: "G",
    7713: "g",
    7714: "H",
    7715: "h",
    7716: "H",
    7717: "h",
    7718: "H",
    7719: "h",
    7720: "H",
    7721: "h",
    7722: "H",
    7723: "h",
    7724: "I",
    7725: "i",
    7728: "K",
    7729: "k",
    7730: "K",
    7731: "k",
    7732: "K",
    7733: "k",
    7734: "L",
    7735: "l",
    7738: "L",
    7739: "l",
    7740: "L",
    7741: "l",
    7742: "M",
    7743: "m",
    7744: "M",
    7745: "m",
    7746: "M",
    7747: "m",
    7748: "N",
    7749: "n",
    7750: "N",
    7751: "n",
    7752: "N",
    7753: "n",
    7754: "N",
    7755: "n",
    7764: "P",
    7765: "p",
    7766: "P",
    7767: "p",
    7768: "R",
    7769: "r",
    7770: "R",
    7771: "r",
    7774: "R",
    7775: "r",
    7776: "S",
    7777: "s",
    7778: "S",
    7779: "s",
    7786: "T",
    7787: "t",
    7788: "T",
    7789: "t",
    7790: "T",
    7791: "t",
    7792: "T",
    7793: "t",
    7794: "U",
    7795: "u",
    7796: "U",
    7797: "u",
    7798: "U",
    7799: "u",
    7804: "V",
    7805: "v",
    7806: "V",
    7807: "v",
    7808: "W",
    7809: "w",
    7810: "W",
    7811: "w",
    7812: "W",
    7813: "w",
    7814: "W",
    7815: "w",
    7816: "W",
    7817: "w",
    7818: "X",
    7819: "x",
    7820: "X",
    7821: "x",
    7822: "Y",
    7823: "y",
    7824: "Z",
    7825: "z",
    7826: "Z",
    7827: "z",
    7828: "Z",
    7829: "z",
    7835: "s",
    7840: "A",
    7841: "a",
    7842: "A",
    7843: "a",
    7864: "E",
    7865: "e",
    7866: "E",
    7867: "e",
    7868: "E",
    7869: "e",
    7880: "I",
    7881: "i",
    7882: "I",
    7883: "i",
    7884: "O",
    7885: "o",
    7886: "O",
    7887: "o",
    7908: "U",
    7909: "u",
    7910: "U",
    7911: "u",
    7922: "Y",
    7923: "y",
    7924: "Y",
    7925: "y",
    7926: "Y",
    7927: "y",
    7928: "Y",
    7929: "y",
    8305: "i",
    8341: "h",
    8342: "k",
    8343: "l",
    8344: "m",
    8345: "n",
    8346: "p",
    8347: "s",
    8348: "t",
    8450: "c",
    8458: "g",
    8459: "h",
    8460: "h",
    8461: "h",
    8464: "i",
    8465: "i",
    8466: "l",
    8467: "l",
    8468: "l",
    8469: "n",
    8472: "p",
    8473: "p",
    8474: "q",
    8475: "r",
    8476: "r",
    8477: "r",
    8484: "z",
    8488: "z",
    8492: "b",
    8493: "c",
    8495: "e",
    8496: "e",
    8497: "f",
    8498: "F",
    8499: "m",
    8500: "o",
    8506: "q",
    8513: "g",
    8514: "l",
    8515: "l",
    8516: "y",
    8517: "d",
    8518: "d",
    8519: "e",
    8520: "i",
    8521: "j",
    8526: "f",
    8579: "C",
    8580: "c",
    8765: "s",
    8766: "s",
    8959: "z",
    8999: "x",
    9746: "x",
    9776: "i",
    9866: "i",
    10005: "x",
    10006: "x",
    10007: "x",
    10008: "x",
    10625: "z",
    10626: "z",
    11362: "L",
    11364: "R",
    11365: "a",
    11366: "t",
    11373: "A",
    11374: "M",
    11375: "A",
    11390: "S",
    11391: "Z",
    19904: "i",
    42893: "H",
    42922: "H",
    42923: "E",
    42924: "G",
    42925: "L",
    42928: "K",
    42929: "T",
    62937: "x"
  };
}, function (e) {
  e.exports = {
    abalone: 4,
    abare: 3,
    abbruzzese: 4,
    abed: 2,
    aborigine: 5,
    abruzzese: 4,
    acreage: 3,
    adame: 3,
    adieu: 2,
    adobe: 3,
    anemone: 4,
    apache: 3,
    aphrodite: 4,
    apostrophe: 4,
    ariadne: 4,
    cafe: 2,
    calliope: 4,
    catastrophe: 4,
    chile: 2,
    chloe: 2,
    circe: 2,
    coyote: 3,
    daphne: 2,
    epitome: 4,
    eurydice: 4,
    euterpe: 3,
    every: 2,
    everywhere: 3,
    forever: 3,
    gethsemane: 4,
    guacamole: 4,
    hermione: 4,
    hyperbole: 4,
    jesse: 2,
    jukebox: 2,
    karate: 3,
    machete: 3,
    maybe: 2,
    newlywed: 3,
    penelope: 4,
    people: 2,
    persephone: 4,
    phoebe: 2,
    pulse: 1,
    queue: 1,
    recipe: 3,
    riverbed: 3,
    sesame: 3,
    shoreline: 2,
    simile: 3,
    snuffleupagus: 5,
    sometimes: 2,
    syncope: 3,
    tamale: 3,
    waterbed: 3,
    wednesday: 2,
    yosemite: 4,
    zoe: 2
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);
  var r = n(0),
      o = n.n(r),
      i = n(1),
      s = n.n(i),
      a = n(2),
      u = n.n(a);

  function l(e) {
    return (l = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function c(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function p(e, t) {
    return !t || "object" !== l(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function f(e) {
    return (f = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function h(e, t) {
    return (h = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var d = function (e) {
    function t(e) {
      var n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), n = p(this, f(t).call(this, e));
      var r,
          o,
          i = e.text.split(" "),
          s = [],
          a = 0;
      return i.forEach(function (e, t) {
        var n;
        n = 1 === e.length ? 1 : u()(e), a += n, s.push({
          text: e,
          syllables: n
        }), t < i.length - 1 && (1, s.push({
          space: !0,
          text: " ",
          syllables: 1
        }));
      }), n.props.duration ? r = (o = n.props.duration) / a * .88 : (r = n.props.syllableDuration, o = a * r), n.state = {
        text: "",
        done: !1,
        cursor: !0,
        wordProgress: 0,
        letterProgress: 0,
        duration: 0,
        letterDuration: 0,
        totalDuration: o,
        accumulatedDuration: 0,
        syllableDuration: r,
        totalSyllables: a,
        letterCount: e.text.length,
        wordIntervals: s
      }, n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && h(e, t);
    }(t, e), n = t, (r = [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        this.props.onStart(function () {
          e.next();
        });
      }
    }, {
      key: "next",
      value: function value() {
        var e = this,
            t = this.state.wordProgress;
        if (t > this.state.wordIntervals.length) console.log("stopped");else {
          var n,
              r,
              o = this.state.letterProgress,
              i = this.state.text;
          0 === t ? (t = 1, o = 1, n = this.state.wordIntervals[t - 1]) : (o += 1, n = this.state.wordIntervals[t - 1], o > n.text.length && (o = 1, t += 1, n = this.state.wordIntervals[t - 1])), r = n.space ? 0 : n.syllables * this.state.syllableDuration / n.text.length, i += n.space ? " " : n.text[o - 1];
          var s = this.state.accumulatedDuration,
              a = {
            text: i,
            letterDuration: r,
            letterProgress: o,
            wordProgress: t,
            accumulatedDuration: s += r
          };
          this.setState(a, function () {
            if (t === e.state.wordIntervals.length && o === n.text.length) {
              var r = e.state.wordProgress;
              r++, e.setState({
                wordProgress: r
              }, function () {
                setTimeout(function () {
                  e.setState({
                    done: !0
                  }, function () {
                    e.props.onEnd(), e.props.onended && e.props.onended();
                  });
                }, 1);
              });
            } else setTimeout(function () {
              e.next();
            }, e.state.letterDuration);
          });
        }
      }
    }, {
      key: "render",
      value: function value() {
        var e = "CyberTyperLine";
        return this.props.lineClass && (e += " " + this.props.lineClass), this.props.speaker && (e += " " + this.props.speaker.className), o.a.createElement("div", {
          className: e
        }, this.renderName(), o.a.createElement("span", {
          className: "CyberTyperLineText"
        }, this.state.text), this.renderCursor());
      }
    }, {
      key: "renderName",
      value: function value() {
        return !1 !== this.props.displayName && this.props.speaker && this.props.speaker.name && this.state.text.length ? o.a.createElement("span", {
          className: "CyberTyperLineName"
        }, this.props.speaker.name) : o.a.createElement("span", {
          className: "CyberTyperLineNoName"
        });
      }
    }, {
      key: "renderCursor",
      value: function value() {
        if (!this.state.isDelaying && !this.state.done) return this.state.text.length ? o.a.createElement("span", {
          className: "CyberTyperLineFloatingCursor"
        }) : o.a.createElement("div", {
          className: "CyberTyperLineCursor CyberTyperFlashing"
        });
      }
    }]) && c(n.prototype, r), i && c(n, i), t;
  }(r.Component);

  function y(e) {
    return (y = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function m(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function v(e, t) {
    return !t || "object" !== y(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function g(e) {
    return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function b(e, t) {
    return (b = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var w = function (e) {
    function t(e) {
      var n;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), (n = v(this, g(t).call(this, e))).state = {
        done: !1
      }, n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && b(e, t);
    }(t, e), n = t, (r = [{
      key: "componentDidMount",
      value: function value() {
        var e = this;
        this.props.onStart(function () {
          e.setState({
            done: !0
          }, function () {
            console.log("done"), e.props.onEnd();
          });
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e;
        return e = !this.props.cursor || this.state.done ? o.a.createElement("br", null) : o.a.createElement("span", null, "&nbsp", this.renderCursor()), o.a.createElement("div", {
          className: "CyberTyperLineBreak"
        }, e);
      }
    }, {
      key: "renderCursor",
      value: function value() {
        return o.a.createElement("div", {
          className: "CyberTyperLineCursor"
        });
      }
    }]) && m(n.prototype, r), i && m(n, i), t;
  }(r.Component);

  function x(e) {
    return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function $(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function k(e, t) {
    return !t || "object" !== x(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function C(e) {
    return (C = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function E(e, t) {
    return (E = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var O = function (e) {
    function t(e) {
      var n;
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), (n = k(this, C(t).call(this, e))).events = new s.a();
      var r = e.script,
          o = [];
      r.forEach(function (e) {
        if (e.text && (e.text.forEach ? e.text.forEach(function (t, n) {
          var r = {
            text: t,
            lineNum: o.length,
            lineClass: e.className,
            displayName: e.displayName
          };
          0 === n ? e.speaker && (r.speaker = e.speaker) : e.speaker && (r.speaker = {
            voice: e.speaker.voice,
            className: e.speaker.className
          }), o.push(r);
        }) : e.text.toString && o.push({
          speaker: e.speaker ? e.speaker : null,
          text: e.text.toString(),
          lineClass: e.className,
          name: e.speaker ? e.speaker.name : null,
          lineNum: o.length
        })), e.linebreak) if ("number" == typeof e.linebreak) for (var t = 0; t < e.linebreak; t++) {
          o.push({
            linebreak: !0,
            lineNum: o.length
          });
        } else o.push({
          linebreak: !0,
          lineNum: o.length
        });
      });
      var i = !0;
      return "hideCursorWhenDone" in e && (i = e.hideCursorWhenDone), n.state = {
        hideCursorWhenDone: i,
        script: o,
        lines: [],
        progress: 0,
        done: !1,
        syllableDuration: 300
      }, n.audioCache = {
        playing: null,
        next: null
      }, n;
    }

    var n, r, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && E(e, t);
    }(t, e), n = t, i = [{
      key: "getDerivedStateFromProps",
      value: function value(e, t) {
        return e.start && (t.started = e.start), t;
      }
    }], (r = [{
      key: "getSnapshotBeforeUpdate",
      value: function value(e, t) {
        return this.props.start && !1 === e.start ? {
          started: this.props.start
        } : null;
      }
    }, {
      key: "componentDidMount",
      value: function value() {
        this.props.autostart && this.start();
      }
    }, {
      key: "componentDidUpdate",
      value: function value(e, t, n) {
        n && "started" in n && (n.started ? this.start() : this.stop());
      }
    }, {
      key: "start",
      value: function value() {
        var e = this;
        this.setState({
          started: !0
        }, function () {
          e.cacheNextAudio(0, function (t) {
            e.next();
          });
        });
      }
    }, {
      key: "next",
      value: function value() {
        var e = this;
        console.log("next");
        var t = this.state.progress + 1,
            n = this.state.script;

        if (t <= n.length) {
          var r = n[t - 1],
              o = function o() {
            r.started = !0, r.lineNum = t - 1;
            var n = e.state.lines;
            1 === t && n.push(r), e.setState({
              lines: n,
              progress: t
            });
          };

          r.linebreak ? o() : r.text && (r.speaker && r.voice ? r.cached ? o() : (console.log("waiting for audio cache", r), this.events.once("audio-cached-" + r.lineNum, function (e) {
            o();
          })) : o());
        }
      }
    }, {
      key: "render",
      value: function value() {
        return o.a.createElement("div", {
          className: "CyberTyper"
        }, this.renderLines(), this.renderCursor());
      }
    }, {
      key: "renderCursor",
      value: function value() {
        if (this.state.isDelaying || this.state.done && !this.state.hideCursorWhenDone) return o.a.createElement("div", {
          className: "CyberTyperLineCursor CyberTyperFlashing"
        });
      }
    }, {
      key: "renderLines",
      value: function value() {
        var e = this;
        if (this.state.started) return this.state.lines.map(function (t, n) {
          var r = t.lineNum;
          if (t.started) return t.sayProfile || e.props.defaultSayProfile, t.linebreak ? o.a.createElement(w, {
            key: r,
            delay: t.delay,
            onStart: function onStart(n) {
              e.onStart(r, t, n);
            },
            onEnd: function onEnd() {
              e.onEnd(r, t);
            }
          }) : o.a.createElement(d, {
            key: r,
            text: t.text,
            speaker: t.speaker,
            lineClass: t.lineClass,
            displayName: t.displayName,
            name: t.name,
            duration: t.duration,
            delay: t.delay,
            syllableDuration: e.state.syllableDuration,
            onStart: function onStart(n) {
              e.onStart(r, t, n);
            },
            onEnd: function onEnd() {
              e.onEnd(r, t);
            }
          });
        });
      }
    }, {
      key: "onStart",
      value: function value(e, t, n) {
        var r = this;
        t.onstarted && t.onstarted(), t.linebreak ? (this.audioCache.next = null, this.cacheNextAudio(e + 1), n()) : t.text && (t.speaker && t.speaker.voice ? t.cached ? this.audioCache.next.lineNum === e ? (this.audioCache.current = this.audioCache.next, this.audioCache.next = null, this.cacheNextAudio(e + 1), this.playCurrentAudio(), n()) : console.log("wrong num", this.audioCache.next) : (console.log("audio onStart NOT CACHED wait for", t), this.events.once("audio-cached-" + t.lineNum, function (o) {
          console.log("audio onStart GOT CACHED", t), r.audioCache.current = r.audioCache.next, r.audioCache.next = null, r.cacheNextAudio(e + 1), r.playCurrentAudio(), n();
        })) : (this.cacheNextAudio(e + 1), n()));
      }
    }, {
      key: "playCurrentAudio",
      value: function value() {
        var e = this,
            t = this.audioCache.current,
            n = this.audioCache.current.audioContext,
            r = this.audioCache.current.source;
        r.connect(n.destination), r.onended = function () {
          n.close(), t.lineEnded ? e.next() : t.audioEnded = !0;
        }, r.start(0);
      }
    }, {
      key: "cacheNextAudio",
      value: function value(e, t) {
        var n = this;

        if (this.state.script[e]) {
          var r = this.state.script[e],
              o = this.state.script;
          if (r.linebreak) t && t(null);else {
            if (r.speaker && !r.speaker.voice) return console.log("NO SPEAKER VOICE"), void (t && t(null));
            var i = {};
            r.speaker && r.speaker.voice ? i.profile = r.speaker.voice : i.profile = this.props.sayProfile, this.props.say.getWorkerAudioData(r.text, i, function (i, s) {
              var a = 1e3 * s.buffer.duration;
              r.duration = a, r.cached = !0, n.audioCache.next = {
                lineNum: e,
                audioContext: i,
                source: s,
                audioEnded: !1
              }, n.setState({
                script: o
              }, function () {
                n.events.emit("audio-cached-" + r.lineNum, a), t && t(a);
              });
            });
          }
        } else console.log("no nextIndex", e);
      }
    }, {
      key: "onEnd",
      value: function value(e, t) {
        var n = this,
            r = this.props.lineBreakDuration,
            o = this.state.progress + 1,
            i = this.state.script;

        if (o <= i.length) {
          var s = i[o - 1].delay || r,
              a = this.state.lines;
          a.push(i[o - 1]), this.props.maxLines && a.length > this.props.maxLines && a.splice(0, a.length - this.props.maxLines), this.setState({
            isDelaying: !0,
            lines: a
          }, function () {
            setTimeout(function () {
              n.setState({
                isDelaying: !1
              }, function () {
                t.onended && t.onended(), t.linebreak ? n.next() : t.text && (t.speaker && t.speaker.voice ? n.audioCache.current.audioEnded ? n.next() : (console.log("waiting for audio-ended"), n.audioCache.current.lineEnded = !0) : n.next());
              });
            }, s);
          });
        } else this.setState({
          done: !0
        }, function () {
          t.onended && t.onended(), n.props.onComplete && n.props.onComplete();
        });
      }
    }]) && $(n.prototype, r), i && $(n, i), t;
  }(r.Component);

  t.default = O;
}]);